import React, { useEffect, useState } from "react";
import NotFound from "../../components/not-found/NotFound";
import TagIcon from "@mui/icons-material/Tag";
import { useSearchParams } from "react-router-dom";
import { IconButton } from "@mui/material";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { Input, dateFormat } from "../../components/Form";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import useDebounce from "../../hooks/useDebounce";
import toast from "react-hot-toast";
import {
  addHashtagApi,
  deleteHashtagApi,
  getHashTagsApi,
} from "../../services/hashTage";
import ModalBox from "../../components/modal/ModalBox";
import { Button } from "../../components/Button/Button";
import useButtonLoader from "../../hooks/UseButtonLoader";
import { PaginationShow } from "../../comman/action/Pagination";
const HashTagManagement = () => {
  const [searchParam, setSearchParam] = useSearchParams();
  const [search, setSearch] = useState(searchParam.get("query") || "");
  const debounceValue = useDebounce(search || "", 300);
  const activePage = +searchParam.get("page") || 1;
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [buttonref, buttonLoader] = useButtonLoader("Add");

  const [hashTageList, setHashTageList] = useState([]);
  const [total, setTotal] = useState(0);

  const [orderByName, setOrderByName] = useState("");
  const [fieldName, setFieldName] = useState("");
  const [direction, setDirection] = useState("ASC");

  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [titleName, setTitleName] = useState("");

  const [addModal, setAddModal] = useState(false);

  const [input, setInput] = useState({ title: "" });
  const [error, setError] = useState({});

  //--------validation---------------
  const validation = () => {
    let status = true;
    let errorMessage = {};

    if (!input?.title || input?.title === "#") {
      errorMessage["title"] = !input?.title
        ? "Please enter a hashtag"
        : input?.title === "#"
        ? "Please enter a hashtag name"
        : "";
      errorMessage["titleHashtag"] = true;
      status = false;
    }

    setError(errorMessage);
    return status;
  };
  //--------------handle-page------------------------
  const handlePageChange = (event) => {
    searchParam.set("page", event);
    setSearchParam(searchParam);
  };
  //--------------sorting-name------------------------
  const orderByNameFun = () => {
    const newDirection = orderByName === "ASC" ? "DESC" : "ASC";
    setOrderByName(newDirection);
    setFieldName("title");
    setDirection(newDirection);
  };
  //--------------delete-hashtag------------------------
  const deleteHandler = (id, name) => {
    setDeleteModal(true);
    setDeleteId(id);
    setTitleName(name);
  };
  //--------------change-handle------------------------
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "title") {
      let cleanedName = value.trim(); // Remove leading and trailing spaces
      // Add hashtag if not already present
      if (cleanedName !== "" && !cleanedName.startsWith("#")) {
        cleanedName = `#${cleanedName}`;
      }
      setInput({
        ...input,
        [name]: cleanedName,
      });
    }
  };
  //------------------modal-close--------------------------
  const modalClose = () => {
    setAddModal(false);
    setInput({ title: "" });
    setError({});
  };
  //--------------Add-sub-category------------------------
  const addHashtag = async () => {
    const status = validation();
    if (status) {
      try {
        buttonLoader(true);
        const res = await addHashtagApi(input);
        if (res.data.status === 200) {
          toast.success(res?.data?.message);
          setAddModal(false);
          getHashTag();
          buttonLoader(false);
          setInput({ title: "" });
        } else {
          toast.error(res.data.message);
          buttonLoader(false);
        }
      } catch (e) {
        toast.error(e.message);
        buttonLoader(false);
      }
    }
  };
  //------------------listing-Api----------------------------------
  const getHashTag = async (
    page = activePage,
    search = debounceValue,
    sortField = fieldName,
    sortDirection = direction
  ) => {
    showLoader();
    try {
      const res = await getHashTagsApi({
        page,
        search,
        sortField,
        sortDirection,
      });
      if (res?.data?.status === 200) {
        hideLoader();
        setHashTageList(res?.data?.data?.list);
        setTotal(res?.data?.data?.total);
      } else {
        hideLoader();
        toast.error(res?.data?.message);
      }
    } catch (err) {
      hideLoader();
      toast.error(err?.message);
    }
  };
  //----------------delete-hashtag--------------------------
  const deleteHashtag = async () => {
    try {
      const res = await deleteHashtagApi(deleteId);
      if (res?.data?.status === 200) {
        setDeleteModal(false);
        getHashTag();
        toast.success(res?.data?.message);
      } else {
        toast.error(res?.data?.message);
      }
    } catch (err) {
      toast.error(err?.message);
    }
  };
  useEffect(() => {
    if (debounceValue) {
      searchParam.set("query", debounceValue);
    } else {
      searchParam.delete("query");
    }
    if (activePage === 1) {
      searchParam.delete("page");
    }
    setSearchParam(searchParam);
    getHashTag(activePage, debounceValue, fieldName, direction);
  }, [activePage, debounceValue, fieldName, direction]);

  useEffect(() => {
    if (search) {
      searchParam.set("page", "");
    }
  }, [search]);
  return (
    <>
      {loader}
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="TitleBox">
            <h4 className="Title">Hashtags</h4>
            <Button onClick={() => setAddModal(true)}>Create Hashtag</Button>
          </div>
          <div className="FilterBox FilterArea">
            <div className="form-group search">
              <input
                type="search"
                className="form-control"
                placeholder="Search"
                value={search || ""}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>
          <div className="content-table">
            <table>
              <thead>
                <tr>
                  <th>S. No.</th>
                  <th>
                    <div className="sorting-th" onClick={orderByNameFun}>
                      <span>Hashtags</span>
                      {orderByName === "ASC" ? (
                        <ArrowUpwardIcon sx={{ fontSize: 15 }} />
                      ) : (
                        <ArrowDownwardIcon sx={{ fontSize: 15 }} />
                      )}
                    </div>
                  </th>
                  <th>Hashtags ID</th>
                  <th>Created At</th>
                  <th className="text-center"> Action </th>
                </tr>
              </thead>

              <tbody>
                {hashTageList.length > 0 ? (
                  hashTageList.map(
                    ({ _id, title, hashtagNumber, createdAt }, index) => {
                      return (
                        <React.Fragment key={index}>
                          <tr>
                            <td>{++index + (activePage - 1) * 10}</td>
                            <td>{title || "N/A"}</td>
                            <td>{hashtagNumber || "N/A"}</td>
                            <td>{dateFormat(createdAt) || "N/A"}</td>
                            <td>
                              <div className="d-flex justify-content-center">
                                <IconButton
                                  onClick={() => deleteHandler(_id, title)}
                                >
                                  <DeleteForeverIcon
                                    sx={{ color: "red", fontSize: 26 }}
                                  />
                                </IconButton>
                              </div>
                            </td>
                          </tr>
                        </React.Fragment>
                      );
                    }
                  )
                ) : (
                  <NotFound
                    cols={10}
                    msg="No Hashtag Found!"
                    icon={<TagIcon style={{ fontSize: 48 }} />}
                    loader={loader}
                  />
                )}
              </tbody>
            </table>
          </div>
          <PaginationShow
            total={total}
            activePage={activePage}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
      {/* --------delete-hastage-modal---------- */}
      <ModalBox
        status={deleteModal}
        onClose={() => setDeleteModal(false)}
        title="Delete Hashtag"
        description={
          <span>
            Do you want to Delete <strong>{titleName}</strong> ?
          </span>
        }
        action={deleteHashtag}
      />
      {/* --------add-hastage-modal---------- */}
      <ModalBox
        status={addModal}
        onClose={modalClose}
        title="Add Hashtag"
        closeIcon
        custom
        customizedFooter={
          <button className="btn_size" ref={buttonref} onClick={addHashtag}>
            Add
          </button>
        }
      >
        <Input
          type="text"
          name="title"
          className="form-control"
          label="Hashtag"
          placeholder="Enter Hashtag"
          value={input?.title || ""}
          onChange={handleChange}
          maxLength={20}
          error={error.title}
          extraErr={error.titleHashtag}
          condition={input?.title === "#"}
        />
      </ModalBox>
    </>
  );
};

export default HashTagManagement;
